import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://localhost:7086/api';

// Portal API - Public endpoints (no JWT required, uses token)
export const portalApi = {
  // Validate token and get customer session
  validateToken: async (token) => {
    const response = await axios.get(`${API_URL}/portal/validate/${token}`);
    return response.data;
  },

  // Get customer's jobs
  getJobs: async (token) => {
    const response = await axios.get(`${API_URL}/portal/jobs`, {
      params: { token }
    });
    return response.data;
  },

  // Get customer's invoices
  getInvoices: async (token) => {
    const response = await axios.get(`${API_URL}/portal/invoices`, {
      params: { token }
    });
    return response.data;
  },

  // Get specific invoice
  getInvoiceById: async (invoiceId, token) => {
    const response = await axios.get(`${API_URL}/portal/invoices/${invoiceId}`, {
      params: { token }
    });
    return response.data;
  },

  // Submit quote request
  requestQuote: async (token, quoteData) => {
    const response = await axios.post(
      `${API_URL}/portal/request-quote`,
      quoteData,
      { params: { token } }
    );
    return response.data;
  }
};

export default portalApi;